import { Spinner, useToast } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import useTable from '../../../../../hooks/useTable';
import { api } from '../../../../../services/api';
import { apiSensedia } from '../../../../../services/api-sensedia';
import TableLeadsMobile from '../components/TableLeadsMobile';

const LeadsMobile = ({ rowsPerPage, visualization, header, data }: any) => {
  const initialState = [
    {
      ID_MDM__c: '-',
      NOME__c: '-',
      segmento: '-',
      Campanha__c: '-',
      LOGIN__c: '-'
    }
  ];

  const { state }: any = useLocation();
  return (
    <>
      <TableLeadsMobile
        rowsPerPage={5}
        header={state.header}
        data={state.data}
      />
    </>
  );
};

export default LeadsMobile;
